import React from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import Partners from "../components/Appendices/Partners";
import ReloadHandler from "../components/common/ReloadHandler";
import Banner from "../components/Home/Banner";
import Download from "../components/Home/Download";
import OurSustainability from "../components/Home/OurSustainability";
import SecondSustainability from "../components/Home/SecondSustainability";
import Statement from "../components/Home/Statement";

export default function Home() {
	const { t } = useTranslation();
	const statements = [
		{
			img_desktop: "/imgs/home-page/statement.png",
			img_mobile: "/imgs/home-page/statement-mobile.png",
			statement_word : t("statements.statement1.statement_word"),
			position: t("statements.statement1.position"),
			sub_headline: t("statements.statement1.sub_headline"),
			paragraphs: [
				t("statements.statement1.paragraph1"),
				t("statements.statement1.paragraph2"),
				t("statements.statement1.paragraph3"),
				t("statements.statement1.paragraph4"),
			],
			paragraphsMobile: [
				t("statements.statement1.paragraph1"),
				t("statements.statement1.paragraph3"),
				t("statements.statement1.paragraph4"),
			],
			his_highness: t("statements.statement1.his_highness"),
			name: t("statements.statement1.name"),
			title: t("statements.statement1.title"),
		},
		{
			img_desktop: "/imgs/home-page/statement2.png",
			img_mobile: "/imgs/home-page/statement2-mobile.png",
			statement_word : t("statements.statement2.statement_word"),
			position: t("statements.statement2.position"),
			sub_headline: t("statements.statement2.sub_headline"),
			paragraphs: [
				t("statements.statement2.paragraph1"),
				t("statements.statement2.paragraph2"),
				t("statements.statement2.paragraph3"),
				t("statements.statement2.paragraph4"),
			],
			paragraphsMobile: [
				t("statements.statement2.paragraph1"),
				t("statements.statement2.paragraph3"),
				t("statements.statement2.paragraph4"),
			],
			his_highness: t("statements.statement2.his_highness"),
			name: t("statements.statement2.name"),
			title: t("statements.statement2.title"),
		},
	];
	
	// ReloadHandler()
	

	return (
		<div>
			<Helmet>
				<title>{t("head.website_title")}</title>
			</Helmet>
			<Banner />
			{/* <OurSustainability /> */}
			<Statement data={statements[0]} />
			<Statement data={statements[1]} secondStatement />
			{/* <SecondSustainability /> */}
			<Partners/>
			{/* <Download /> */}
		</div>
	);
}
